import React, { useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation
} from "react-router-dom";

import Home from "./pages/Home";
import Gallery from "./pages/Gallery";


import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const location = useLocation();
  const nodeRef = useRef(null);

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* HEADER */}
      <header style={{ backgroundColor: "#1D3F3E" }} className="text-white p-2">
        <div className="container d-flex flex-column flex-md-row align-items-center">
          <Link to="/" className="text-white text-decoration-none">
            <h1 className="my-0 mr-md-auto">Liliana Kużdowicz</h1>
          </Link>
          <nav className="my-2 my-md-0 mr-md-3">
            <Link to="/galeria" className="p-2 text-white text-decoration-none">
              Galeria
            </Link>
          </nav>
        </div>
      </header>

      {/* GŁÓWNA CZĘŚĆ */}
      <main className="flex-fill">
        <div ref={nodeRef}>
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/galeria" element={<Gallery />} />
            
          </Routes>
        </div>
      </main>

      {/* STOPKA */}
      <footer style={{ backgroundColor: "#1D3F3E" }} className="text-white text-center p-2 mt-auto">
        <div className="container">
          <p>2025</p>
        </div>
      </footer>
    </div>
  );
}

export default AppWrapper;